import { Badge } from '@material-ui/core';
import { AssembleiaChatModal } from 'components/Modal/__LEGACY__/AssembleiaChatModal';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import Context from '../../Context';
import styles from './BotaoFlutuante.scss';
const rootClassName = styles.rootClassName;

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
}

export const BotaoFlutuante: React.FC<ButtonProps> = ({ icon, ...props }) => {
  const [isShowChatModal, setIsShowChatModal] = useState(false);
  const [showNotify, setIsShowNotify] = useState(false);

  const { perguntas, isPerguntaUsuario, isPerguntaNaoLida } =
    useContext(Context);

  const closeModal = () => {
    setIsShowChatModal(false);
  };

  const openChatModal = () => {
    setIsShowChatModal(true);
  };

  const getStorage: any = localStorage.getItem('notificacaoChat');
  const parseStorage = JSON.parse(getStorage);

  const perguntasNaoLidasUsuario = useMemo(() => {
    return (perguntas || [])
      .filter(isPerguntaUsuario)
      .filter(isPerguntaNaoLida);
  }, [isPerguntaNaoLida, isPerguntaUsuario, perguntas]);

  const perguntasNaoLidasGeral = useMemo(() => {
    return (perguntas || []).filter(isPerguntaNaoLida);
  }, [isPerguntaNaoLida, perguntas]);

  useEffect(() => {
    if (isShowChatModal && !localStorage.getItem('badgeConfig')) {
      setIsShowNotify(false);
    } else if (
      isShowChatModal &&
      localStorage.getItem('badgeConfig') &&
      invisibleBadge() >= 1
    ) {
      setIsShowNotify(false);
    } else if (localStorage.getItem('badgeConfig') && invisibleBadge() === 0) {
      setIsShowNotify(false);
    } else {
      setIsShowNotify(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perguntas, isShowChatModal]);

  const invisibleBadge: any = () => {
    if (localStorage.getItem('badgeConfig')) {
      if (parseStorage?.somenteMinhasNotificacoes! === true) {
        return perguntasNaoLidasUsuario?.length;
      } else {
        return perguntasNaoLidasGeral?.length;
      }
    }
  };

  return (
    <>
      <AssembleiaChatModal
        show={isShowChatModal}
        onCancel={() => closeModal()}
      />
      <div className={rootClassName} onClick={openChatModal}>
        <Badge
          invisible={!showNotify}
          variant={'dot'}
          color={'error'}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <button {...props}>{icon ? icon : ''}</button>
        </Badge>
      </div>
    </>
  );
};
